import React from "react";
import { useParams } from "react-router-dom";
import SettingsPage from "../../components/Design/Settings/SettingsPage";
import SettingsPageContent from "../../components/Design/Settings/SettingsPageContent";
import { Routing } from "../../data/Constants/Routing";
import { useApiStates } from "../../state/Store";
import ScenarioForm from "./ScenarioForm";

interface Params extends Record<string, string | undefined> {
    scenarioId: string;
}

const EditScenarioScreen: React.FC = () => {
    const params = useParams<Params>();

    const api = useApiStates("scenarios", "roles");
    const scenario = api.scenarios.value?.find(r => r.id === params.scenarioId);

    return (
        <SettingsPage
            breadcrumbs={[{
                title: "Szenarien",
                link: Routing.Administration.Scenario.Navigate()
            }]}
            title={scenario?.name ?? "Szenario bearbeiten"}>

            <SettingsPageContent
                api={api}
                error={!scenario && "Szenario nicht gefunden!"}>

                <ScenarioForm
                    availableRoles={api.roles.value ?? []}
                    scenario={scenario} />

            </SettingsPageContent>

        </SettingsPage>
    );
};

export default EditScenarioScreen;
